/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useMailData } from "../../Utility";
import { onSendMail, onSendMailReset } from "../../Store/Slices/mailSlice";
import "./LoginPage.css";

function AdminForgotPasswordPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const mailData = useMailData();

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const isLoading = mailData?.sendLoading ?? false;
  const apiError = mailData?.sendError ? mailData?.sendMessage : null;
  const isSuccess =
    mailData?.sendStatusCode === 200 ||
    mailData?.sendStatusCode === "200" ||
    mailData?.sendStatusCode === 201 ||
    mailData?.sendStatusCode === "201";

  useEffect(() => {
    dispatch(onSendMailReset());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      
      setSubmitted(true);
      dispatch(onSendMailReset());
    }
  }, [isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const trimmed = email.trim();
    if (!trimmed) {
      setError("Please enter your email address.");
      return;
    }
    if (!/\S+@\S+\.\S+/.test(trimmed)) {
      setError("Please enter a valid email address.");
      return;
    }
    dispatch(
      onSendMail({
        to: trimmed,
        type: "resetpassword",
      }),
    );
  };

  return (
    <div className="admin-login-page admin-login-page-forgot">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <button
            type="button"
            className="admin-login-back"
            onClick={() => navigate("/admin/login")}
            aria-label="Back to admin login"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to login
          </button>
          <div className="admin-login-header">
            <div className="admin-login-icon">🔑</div>
            <h1 className="admin-login-title">Forgot password?</h1>
            <p className="admin-login-subtitle">
              Enter your admin email and we&apos;ll send you a link to reset
              your password.
            </p>
          </div>
          {!submitted ? (
            <form className="admin-login-form" onSubmit={handleSubmit}>
              <div className="admin-form-group">
                <label
                  htmlFor="admin-forgot-email"
                  className="admin-form-label"
                >
                  Email address
                </label>
                <div className="admin-input-wrapper">
                  <input
                    type="email"
                    id="admin-forgot-email"
                    name="email"
                    className={`admin-form-input ${error ? "input-error" : ""}`}
                    placeholder="admin@weddingzvenue.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                  />
                </div>
                {error && <span className="admin-error-message">{error}</span>}
                {apiError && (
                  <span className="admin-error-message">{apiError}</span>
                )}
              </div>
              <button
                type="submit"
                className="admin-login-btn"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send reset link"}
              </button>
            </form>
          ) : (
            <div className="admin-forgot-success">
              <div className="admin-forgot-success-icon" aria-hidden="true">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <p className="admin-forgot-success-title">Check your email</p>
              <p className="admin-forgot-success-text">
                The link has been sent to the email <strong>{email}</strong>.
                Please check your email for the link.
              </p>
              <Link
                to="/admin/login"
                className="admin-login-btn admin-forgot-success-btn"
              >
                Back to login
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminForgotPasswordPage;
